let enabled = false;

export const enableAppSwitcher = () => {
  enabled = true;
};

export const isAppSwitcherEnabled = (): boolean => {
  return enabled;
};
